import {
    SET_TOTAL_PRICE,
} from "../actions/types";

const initialState = null;

function priceReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_TOTAL_PRICE:
            return payload;
        default:
            return state;
    }
};

export default priceReducer;
